import axios from '../axios'

// フィードバック修正（本人・1回）。payload = { rating, message }
const patchFeedbackApi = async (feedbackId, payload) => {
  return await axios.patch(`api/lms/feedback/${feedbackId}`, payload)
}

export default patchFeedbackApi
